import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import TestimonialsPanel from './TestimonialsPanel'
import DividerSection from './DividerSection'
import Cookies from 'universal-cookie'
import { shouldTranslateTo } from '../utils/utils'
import { getCurrencySign } from '../utils/utils'
import { Link } from 'react-router-dom'
import {
  Title,
  Subtitle,
  ContainerFlexColumn,
  PrimaryButton,
} from './Utils/CustomClasses'

const cookies = new Cookies()

const Container = styled.div``

const ContentWrapper = styled(ContainerFlexColumn)`
  background-color: ${({ color }) => (color ? color : '#fff')};
`

const FullWidthButton = styled(PrimaryButton)`
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

const FullWidthButtonTwo = styled(FullWidthButton)`
  margin: 0 0 80px 0;
`

const Testimonials = () => {
  const [pageText, setPageText] = React.useState([])
  const [pageText2, setPageText2] = React.useState([])
  const [pageText3, setPageText3] = React.useState([])
  const [currencySign, setCurrencySign] = useState('')

  useEffect(() => {
    const language = shouldTranslateTo()

    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('how-it-works-v3', language, setPageText)
    getPageText('profile-pay', language, setPageText2)
    getPageText('homepage-v2', language, setPageText3)

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(cookies.get('cV'))
      setCurrencySign(currencySignData.sign)
    }
    getCurrency()
  }, [])

  if (pageText.length === 0 || pageText2.length === 0 || !currencySign) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <Container>
      <ContentWrapper
        color={'#F6F0E6'}
        padding="4vh 15vw 6vh 15vw"
        paddingSm="4vh 5vw 6vh 5vw"
      >
        <TestimonialsPanel
          color={'#F6F0E6'}
          showintro={true}
          numbertoshow={10}
        />
      </ContentWrapper>

      {/* Divider */}
      <DividerSection colorType={5} color={'#F6F0E6'} flip={false} />

      {/* Become a Member */}
      <ContainerFlexColumn
        center
        padding="8vh 15vw 6vh 15vw"
        paddingSm="7vh 5vw 4vh 5vw"
        background="#154549"
      >
        <Title
          color="#FFFFFF"
          size="46px"
          sizemd="40px"
          sizesm="38px"
          center
          margin="0 10vw 40px 10vw"
          marginmd="0 10vw 40px 10vw"
          marginsm="20px 0 40px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[61]}`,
          }}
        ></Title>
        <Subtitle
          center
          weight="300"
          color="#FFFFFF"
          size="22px"
          sizemd="22px"
          sizesm="22px"
          margin="0 7vw 50px 7vw"
          marginsm="0 8px 40px 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[62]}`,
          }}
        />
        <Link to="/signup">
          <FullWidthButtonTwo>
            <a>{pageText[63]}</a>
          </FullWidthButtonTwo>
        </Link>
      </ContainerFlexColumn>
    </Container>
  )
}
export default Testimonials
